import React from 'react'
import useFormValidation from "../../components/auth/useFormValidation";
import validateCreateTema from "../../components/auth/validateCreateTema";
import FirebaseContext from "../../firebase/context";
import { Link, withRouter } from "react-router-dom";

import TableCell from '@material-ui/core/TableCell';
import { Button, TableRow, TextField, Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import CompUpload from './CompUpload';

const CompTemaListEdit = ({ props, tema, setShowTemaFormEdit, setUpdateTemaList, index, setPracticaURL, practicaURL}) => {
    
    const { firebase, user } = React.useContext(FirebaseContext);
    const INITIAL_STATE = {
        tituloTema: tema.tituloTema,
        video: tema.video,
        practica: tema.practica,
    };

    React.useEffect(() => {
        setPracticaURL("")
    }, [])

    
    const { handleSubmit, handleChange, values, errors } = useFormValidation(
        INITIAL_STATE,
        validateCreateTema,
        handleCreateTema
    );
    let idTema = tema.id

    function handleCreateTema() {
        if (!user) {
            props.history.push("/login");
        } else {
            const { tituloTema, video } = values;
            const practica = practicaURL
            const editTema = {
                tituloTema,
                video,
                practica,

            };

            firebase.db.collection("colTemas").doc(idTema).set(editTema, { merge: true });
            setShowTemaFormEdit(false);
            setUpdateTemaList(index)
        }
    }

    return (
        <React.Fragment key={index}>
            <TableRow  >
                <TableCell align='justify'>
                    <form onSubmit={handleSubmit} >

                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Titulo de Tema"
                            name="tituloTema"
                            margin="normal"
                            placeholder="Titulo de Tema"
                            autoComplete="off"
                            type="text"
                            onChange={handleChange}
                            className={errors.tituloTema && "error-input"}
                            value={values.tituloTema}
                        />
                        {errors.tituloTema && <p className="error-text">{errors.tituloTema}</p>}
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Direccion URL de Video"
                            name="video"
                            margin="normal"
                            placeholder="Direccion URL de Video"
                            autoComplete="off"
                            type="text"
                            onChange={handleChange}
                            className={errors.video && "error-input"}
                            value={values.video}
                        />
                        {errors.video && <p className="error-text">{errors.video}</p>}
                        <Typography >URL de Practica: {tema.practica}</Typography>
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            className="button"
                            type="submit"
                            startIcon={<CheckIcon />}
                        >
                            ACTUALIZAR
                               </Button>
                        <Button
                            variant="contained"
                            color="error"
                            size="small"
                            type="button"
                            onClick={() => setShowTemaFormEdit(false)}
                            startIcon={<CancelIcon />}
                        >
                            CANCELAR
                               </Button>
                    </form>
                </TableCell>
                <TableCell>
                    <Typography >URL de Practica: {practicaURL}</Typography>
                    <CompUpload setPracticaURL={setPracticaURL} />
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default withRouter(CompTemaListEdit)
